import { transition, trigger, useAnimation } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { fadeIn } from 'ng-animate';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { finalize } from 'rxjs/operators';
import { Filial } from './filial';

@Component({
  selector: 'app-filial-selector',
  templateUrl: './filial-selector.component.html',
  styleUrls: ['./filial-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilialSelectorComponent),
      multi: true,
    },
  ],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', useAnimation(fadeIn), {
        params: { timing: 0.2 },
      }),
    ]),
  ],
})
export class FilialSelectorComponent
  implements OnInit, OnChanges, OnDestroy, ControlValueAccessor
{
  @Input() public showAlways = false;
  @Input() public unp!: string;
  @Input() public params: { [key: string]: string } = {};
  @Output() public showFilialSelect!: boolean;
  public value: string;
  public items!: Filial[];
  public isLoading = false;
  public disabled = false;

  constructor(private http: HttpClient) {}

  public ngOnInit() {}

  public ngOnDestroy(): void {}

  public ngOnChanges(): void {
    if (this.unp) {
      if (/^\d{9}$/.test(this.unp)) {
        this.getFilials(this.unp);
      } else {
        this.value = undefined;
        this.updateValue(this.value);
        this.showFilialSelect = false;
      }
    } else {
      this.value = undefined;
      this.updateValue(this.value);
      this.showFilialSelect = false;
    }
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  public writeValue(outsideValue: string) {
    this.value = outsideValue;
  }

  public setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  public updateValue(insideValue: string) {
    this.value = insideValue;
    this.onChange(insideValue);
    this.onTouched();
  }

  public customSearchFn(term: string, item: Filial) {
    const combinedString = item.name || '' + item.code;

    return combinedString.toLowerCase().indexOf(term.toLowerCase()) !== -1;
  }

  private onChange = (value: any) => {};
  private onTouched = () => {};

  private getFilials(unp: string) {
    this.items = undefined;
    this.value = undefined;
    this.updateValue(this.value);
    this.isLoading = true;
    this.http
      .get<Filial[]>(`/v1/filials?trn=${unp}`, { params: this.params })
      .pipe(
        untilDestroyed(this),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((res) => {
        this.items = res;
        this.showFilialSelect = !!(this.items && this.items.length);
      });
  }
}
